export default function Features() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'Intelligent Product Discovery',
      description: 'Our advanced AI algorithms understand your preferences and shopping behavior to recommend products you\'ll love. Experience personalized shopping like never before with machine learning-powered suggestions.',
      color: 'from-indigo-500 to-purple-500',
      image: 'https://public.readdy.ai/ai/img_res/5dfcf6fcd9dea13a61b9d8c21b43783a.jpg'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Automated Analytics Dashboard',
      description: 'Real-time insights and predictive analytics help suppliers make data-driven decisions. Track sales trends, customer behavior, inventory levels, and market opportunities with our comprehensive analytics suite.',
      color: 'from-blue-500 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=Modern%20analytics%20dashboard%20displaying%20real-time%20sales%20charts%2C%20revenue%20graphs%2C%20customer%20insights%2C%20and%20predictive%20analytics%20visualizations%2C%20professional%20business%20intelligence%20interface%20with%20colorful%20data%20representations%2C%20clean%20design%20with%20blue%20gradient%20accents%2C%20multiple%20metrics%20and%20KPIs&width=500&height=400&seq=feature-002&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: 'Efficient Fulfillment Management',
      description: 'Streamline your entire supply chain with AI-optimized logistics. From inventory management to last-mile delivery, our platform ensures fast, reliable, and cost-effective order fulfillment.',
      color: 'from-green-500 to-emerald-500',
      image: 'https://readdy.ai/api/search-image?query=Smart%20logistics%20and%20fulfillment%20management%20system%20showing%20automated%20warehouse%20operations%2C%20delivery%20tracking%20map%20with%20route%20optimization%2C%20inventory%20management%20interface%2C%20package%20tracking%20visualization%2C%20modern%20supply%20chain%20technology%20with%20green%20accents%2C%20professional%20business%20setting&width=500&height=400&seq=feature-003&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure Payment Processing',
      description: 'Enterprise-grade security with multiple payment options. Our platform supports all major payment methods with end-to-end encryption, fraud detection, and PCI compliance for peace of mind.',
      color: 'from-orange-500 to-red-500',
      image: 'https://readdy.ai/api/search-image?query=Secure%20payment%20processing%20interface%20showing%20encrypted%20transactions%2C%20multiple%20payment%20method%20icons%2C%20security%20shield%20symbols%2C%20fraud%20detection%20system%2C%20modern%20fintech%20dashboard%20with%20orange%20and%20red%20gradient%2C%20professional%20banking%20technology%20design&width=500&height=400&seq=feature-004&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 AI Customer Support',
      description: 'Never leave your customers waiting. Our intelligent chatbot provides instant responses, handles common queries, and escalates complex issues to human agents when needed.',
      color: 'from-pink-500 to-rose-500',
      image: 'https://readdy.ai/api/search-image?query=AI%20chatbot%20customer%20support%20interface%20with%20conversation%20bubbles%2C%20virtual%20assistant%20avatar%2C%20real-time%20messaging%20system%2C%20help%20desk%20dashboard%2C%20friendly%20customer%20service%20technology%20with%20pink%20gradient%20accents%2C%20modern%20communication%20platform%20design&width=500&height=400&seq=feature-005&orientation=landscape'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Mobile-First Experience',
      description: 'Shop and sell on the go with our responsive mobile platform. Optimized for all devices, our marketplace delivers a seamless experience whether you\'re on desktop, tablet, or smartphone.',
      color: 'from-violet-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20e-commerce%20app%20interface%20showing%20responsive%20design%20on%20smartphone%2C%20modern%20shopping%20experience%20with%20product%20browsing%2C%20touch-friendly%20interface%2C%20mobile%20payment%20system%2C%20sleek%20app%20design%20with%20purple%20gradient%2C%20professional%20mobile-first%20platform&width=500&height=400&seq=feature-006&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line text-indigo-600"></i>
            <span className="text-sm font-semibold text-indigo-600">POWERFUL FEATURES</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Everything You Need to Succeed
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our AI-driven platform combines cutting-edge technology with user-friendly design to deliver an unmatched e-commerce experience for both buyers and sellers.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start space-x-6">
                <div className={`w-14 h-14 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{feature.description}</p>
                </div>
              </div>
              <div className="mt-6 rounded-xl overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
